var _path, _path2, _g, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrantApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 211,
    viewBox: "0 0 211 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 211C163.766 211 211 163.766 211 105.5C211 47.234 163.766 0 105.5 0C47.234 0 0 47.234 0 105.5C0 163.766 47.234 211 105.5 211Z",
    fill: "#F7F9FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4178_1319",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 211,
    height: 211
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 211C163.766 211 211 163.766 211 105.5C211 47.234 163.766 0 105.5 0C47.234 0 0 47.234 0 105.5C0 163.766 47.234 211 105.5 211Z",
    fill: "#F7F9FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4178_1319)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.9014,
    y: 74.6113,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3506,
    y: 69.0605,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1055,
    y: 63.5098,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9326,
    y: 74.8057,
    width: 104.082,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9326,
    y: 89.0039,
    width: 4.85716,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2598,
    y: 89.0039,
    width: 32.6124,
    height: 4.85716,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2598,
    y: 96.6367,
    width: 95.7555,
    height: 18.0409,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9326,
    y: 125.086,
    width: 4.85716,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2598,
    y: 125.086,
    width: 32.6124,
    height: 4.85716,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2598,
    y: 133.413,
    width: 84.6534,
    height: 9.02044,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9326,
    y: 153.535,
    width: 4.85716,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2598,
    y: 153.535,
    width: 32.6124,
    height: 4.85716,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6465,
    y: 162.082,
    width: 95.0666,
    height: 60.9861,
    fill: "#EDEFF0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.343,
    cy: 36.5881,
    r: 14.1565,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.5 12C163.693 12 152.5 23.1932 152.5 37C152.5 50.8068 163.693 62 177.5 62C191.307 62 202.5 50.8068 202.5 37C202.5 23.1932 191.307 12 177.5 12ZM188.336 32.7727C188.536 32.5446 188.688 32.279 188.783 31.9913C188.878 31.7036 188.915 31.3998 188.892 31.0977C188.868 30.7956 188.784 30.5013 188.644 30.2321C188.505 29.9629 188.314 29.7243 188.081 29.5303C187.848 29.3363 187.579 29.1908 187.289 29.1024C186.999 29.014 186.694 28.9845 186.393 29.0155C186.091 29.0466 185.799 29.1376 185.534 29.2833C185.268 29.4289 185.034 29.6262 184.845 29.8636L175.073 41.5886L170.016 36.5295C169.587 36.1156 169.013 35.8865 168.417 35.8917C167.821 35.8968 167.251 36.1358 166.83 36.5572C166.409 36.9786 166.17 37.5486 166.164 38.1445C166.159 38.7404 166.388 39.3145 166.802 39.7432L173.62 46.5614C173.844 46.7845 174.111 46.9587 174.405 47.0729C174.7 47.187 175.015 47.2385 175.33 47.2242C175.646 47.2099 175.954 47.13 176.237 46.9897C176.52 46.8493 176.771 46.6516 176.973 46.4091L188.336 32.7727Z",
    fill: "#2FED64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantApproved);
export default __webpack_public_path__ + "static/media/grantApproved.8da59fa9e413b7d15e5d110e9ebd8410.svg";
export { ForwardRef as ReactComponent };